import { render, staticRenderFns } from "./EmptyBlogDrawer.vue?vue&type=template&id=7c1ff5b6&scoped=true&"
var script = {}
import style0 from "./EmptyBlogDrawer.vue?vue&type=style&index=0&id=7c1ff5b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1ff5b6",
  null
  
)

export default component.exports